export function calculateHours(entries) {
    const partial = entries.reduce((timesheetHours, entry) => {
        if (entry.duration === null) {
            return timesheetHours;
        }
        const duration = Number.parseInt(`${entry.duration}`, 10);
        if (entry.billable) {
            timesheetHours.totalBillable += duration;
        }
        else {
            timesheetHours.totalNonBillable += duration;
        }
        return timesheetHours;
    }, {
        totalBillable: 0,
        totalNonBillable: 0,
    });
    return {
        ...partial,
        totalHours: partial.totalBillable + partial.totalNonBillable,
    };
}
//# sourceMappingURL=billable.js.map